import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_BACK_NODE}/usuarios`

export function obtenerUsuarios(userId) {
  return http.get(`${API_ENDPOINT}/obtenerUsuarios`, {
    params: { userId }
  })
}

export function guardarUsuarios(payload) {
  return http.post(`${API_ENDPOINT}/guardarUsuarios`, payload)
}

export function actualizarUsuario(payload) {
  return http.post(`${API_ENDPOINT}/actualizarUsuario`, payload)
}
